export default __webpack_public_path__ + "static/media/upload.28c79958.svg";